import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";

export default function AsmaulHusnaJsonUpdater() {
  // const [level3optHide, setLevel3optHide] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm();

  const handleJsonUpdate = (data) => {
    const course = data.course;
    const batchNo = parseInt(data.batch);
    const exmNo = parseInt(data.exm);
    const dateType = data.type;
    const level = 1;
    const jsonData = JSON.parse(data.jsondata);

    if (dateType === "register") {
      console.log("I'm registering new students!");
      jsonData.map((data) => {
        const insertData = {
          sn: parseInt(data.sn),
          name: data.name.toLowerCase(),
          fatherName: data.fatherName.toLowerCase(),
          phone: String(data.phone),
          gender: data.gender,
          [`${course}${level}payment`]: data[`${course}${level}payment`],
          [`${course}${level}data`]: Array.from({ length: exmNo }, (_, i) => ({
            name: `Exm ${i + 1}`,
            Score: 0,
          })),
          completion: 0,
          [`${course}${level}total`]: 0,
          gems: 0,
          todaysinfo: {
            dua: 0,
            date: "",
          },
          dua: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0,
          ],
        };

        axios
          .post(
            `${process.env.REACT_APP_BACKEND_API}/${course}/${batchNo}/register`,
            insertData
          )
          .then((data) => {
            console.log("Registration Successfull ! Student " + insertData?.sn);
          });
      });
    } else if (dateType === "update") {
      console.log("updating");
      jsonData.map((data) => {
        const insertData = {
          sn: parseInt(data.sn),
          completion: data.completion,
          gems: data.gems,
        };
        //process.env.REACT_APP_BACKEND_API
        axios
          .put(
            `${"http://localhost:5000"}/${course}/json_update/${batchNo}/${
              insertData.sn
            }`,
            insertData
          )
          .then((data) => {
            console.log("Updated Successfully ! Student " + insertData?.sn);
          });
      });
    } else {
      console.log("i cann't update, Data type is unknown!");
    }
  };

  const placeholderText = `[ 
              
  
  
              //Register:   
              {
                  "sn": 3,
                  "name" : "faisal",
                  "fatherName" : "abc",
                  "phone" : "0125",
                  "gender" : "male",
                  "aqeedah1payment" : "paid"
              },
  ]
      `;
  return (
    <div>
      <p className="text-2xl text-center mb-5">Result Update</p>
      <section className="bg-green-200 p-5 rounded">
        <p className="text-xl mb-5">JSON</p>

        <form onSubmit={handleSubmit(handleJsonUpdate)}>
          <div className="flex items-end gap-10 mb-5">
            <div className="form-control">
              <label className="label">
                <span className="label-text">Course</span>
              </label>

              <label
                htmlFor="field-asmaulhusna"
                className="flex align-center mb-1"
              >
                <input
                  {...register("course")}
                  type="radio"
                  name="course"
                  value="asmaulhusna"
                  id="field-asmaulhusna"
                  className="radio mr-3 checked:bg-orange-600"
                />
                <span>Asmaul Husna</span>
              </label>
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text">Type</span>
              </label>

              <label
                htmlFor="field-register"
                className="flex align-center mb-1"
              >
                <input
                  {...register("type")}
                  type="radio"
                  name="type"
                  value="register"
                  id="field-register"
                  className="radio mr-3 checked:bg-green-500"
                />
                <span>Register</span>
              </label>

              <label htmlFor="field-update" className="flex align-center mb-1">
                <input
                  {...register("type")}
                  type="radio"
                  name="type"
                  value="update"
                  id="field-update"
                  className="radio mr-3 checked:bg-orange-500"
                />
                <span>Update</span>
              </label>
            </div>

            {/* <div className="form-control">
              <label className="label">
                <span className="label-text">Level</span>
              </label>
              <label htmlFor="field-level1" className="flex align-center mb-1">
                <input
                  {...register("level")}
                  type="radio"
                  name="level"
                  value="1"
                  id="field-level1"
                  className="radio mr-3 checked:bg-pink-600"
                />
                <span>Level 1</span>
              </label>
              <label htmlFor="field-level2" className="flex align-center mb-1">
                <input
                  {...register("level")}
                  type="radio"
                  name="level"
                  value="2"
                  id="field-level2"
                  className="radio mr-3 checked:bg-fuchsia-700"
                />
                <span>Level 2</span>
              </label>
              <label htmlFor="field-level3" className="flex align-center mb-1">
                <input
                  {...register("level")}
                  type="radio"
                  name="level"
                  value="3"
                  id="field-level3"
                  className={`radio mr-3 checked:bg-emerald-600`}
                />
                <span>Level 3</span>
              </label>
            </div> */}

            <div className="form-control">
              <label className="label">
                <span className="label-text">Batch No</span>
              </label>
              <input
                type="text"
                placeholder="19"
                className="input input-bordered w-full max-w-xs"
                {...register("batch", { required: true })}
              />
              {errors.batch?.type === "required" && "Batch Number is required"}
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text">Exm</span>
              </label>
              <input
                type="text"
                placeholder="1"
                className="input input-bordered w-full max-w-xs"
                {...register("exm")}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Upload
            </button>
            {/* <button type='reset' onClick={() => reset()} className='btn btn-warning'>Reset</button> */}
            <input
              onClick={() => clearErrors()}
              type="reset"
              className="btn btn-error"
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text">JSON Data</span>
            </label>
            <textarea
              className="textarea textarea-bordered h-96"
              placeholder={placeholderText}
              {...register("jsondata", { required: true })}
            />
            {errors.jsondata?.type === "required" && "JSON Data is required"}
          </div>
        </form>
      </section>

      <div className="my-10">{/* {JSON.parse(placeholderText)} */}</div>
    </div>
  );
}
